import { Game } from '@phaser/scenes/Game';

export class ScaleSystem {
  private _scene: Game = Game.current;

  constructor() {
    this._initScale();
  }

  _initScale() {
    this._resize();
    window.addEventListener('resize', () => { this._resize();  });
  }

  private _resize() {
    const container = document.querySelector('#game-container');
    if (!container) return;

    const dpr = window.devicePixelRatio;
    const width = container.clientWidth;
    const height = container.clientHeight;

    const widthDPR = Math.round(width * dpr);
    const heightDPR = Math.round(height * dpr);

    if (this._scene.scale.parent) {
      this._scene.scale.parent.width = Math.round(width);
      this._scene.scale.parent.height = Math.round(height);
    }

    this._scene.scale.canvas.width = widthDPR;
    this._scene.scale.canvas.height = heightDPR;

    this._scene.scale.canvas.style.width = Math.round(width) + 'px';
    this._scene.scale.canvas.style.height = Math.round(height) + 'px';

    this._scene.scale.setParentSize(width, height);
    this._scene.scale.setGameSize(widthDPR, heightDPR);

    this._scene.cameras.main.setZoom(dpr).setOrigin(0);
  }
}